import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntroductionComponent } from './introduction.component';
import { TranslationModule } from '../translation/translation.module';
import { IntroductionConfig } from './introduction-config';
import { GoogleMapsOwnModule } from '../google-maps/google-maps.module';



@NgModule({
  declarations: [IntroductionComponent],
  exports: [IntroductionComponent],
  imports: [
    CommonModule, TranslationModule,GoogleMapsOwnModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class IntroductionModule {
    static forRoot(introductionConfig?: IntroductionConfig): ModuleWithProviders<IntroductionModule> {
        const finalConfig = new IntroductionConfig();
        if (introductionConfig) {
            if (introductionConfig.isRowView) finalConfig.isRowView = introductionConfig.isRowView;
        }
        return {
            ngModule: IntroductionModule,
            providers: [
                {
                    provide: IntroductionConfig,
                    useValue: finalConfig
                }
            ]
        };
    }
 }
